import 'normalize.css'
import classes from './main.css'